import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { TransactionsImportComponent } from './components/transactions-import/transactions-import.component';
import { TransactionsImportService } from './services/transactions-import.service';

@NgModule({
    declarations: [
        TransactionsImportComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        AccountSharedModule,
    ],
    providers: [
        TransactionsImportService
    ],
    exports: [
        TransactionsImportComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TransactionsImportModule {
}
